function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Spin, Select, Divider, Space, Tag, Upload } from "antd";
import { Eyedropper, Upload as UploadIc } from 'react-bootstrap-icons';
import Common from "../includes/Common";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var LaboForm = function LaboForm(_ref) {
  var laboratory_result_id = _ref.laboratory_result_id,
    queue_item = _ref.queue_item,
    queue_item_element = _ref.queue_item_element,
    business_account_medical_item = _ref.business_account_medical_item,
    customer = _ref.customer,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    atFile = _useState8[0],
    setAtFile = _useState8[1];
  var _useState9 = useState(queue_item_element && queue_item_element.laboratory_result ? queue_item_element.laboratory_result.result_string : ''),
    _useState0 = _slicedToArray(_useState9, 2),
    resultString = _useState0[0],
    setResultString = _useState0[1];
  var props = {
    onRemove: function onRemove(file) {
      setAtFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setAtFile(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg,.pdf,.doc,.docx",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setSuccessMessage('');
    setErrorMessage('');
    var fd = new FormData();
    fd.append('laboratory_result_id', laboratory_result_id);
    fd.append('result_string', resultString);
    fd.append('business_account_medical_item_id', business_account_medical_item.id.toString());
    fd.append('normal_value', values.normal_value);
    fd.append('attached_file', atFile);
    fd.append('user_id', Common.currentUser.id);
    fd.append('customer_id', customer.id.toString());
    fd.append('queue_item_element_id', queue_item_element.id.toString());
    fd.append('queue_item_id', queue_item.id.toString());
    axios.post(Common.baseApiUrl + 'setlaboresult', fd).then(function (response) {
      setIsFormProcessing(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  useEffect(function () {
    if (queue_item_element.laboratory_result != null) form.setFieldsValue({
      result_string: queue_item_element.laboratory_result.result_string,
      normal_value: queue_item_element.laboratory_result.normal_value != 'null' ? queue_item_element.laboratory_result.normal_value : ''
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx(Eyedropper, {
          size: 30
        }), "SAISIR LE RESULTAT DU LABORATOIRE"]
      }), /*#__PURE__*/_jsx(Tag, {
        color: "#f50",
        children: /*#__PURE__*/_jsx("b", {
          children: business_account_medical_item.label
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "success",
        message: successMessage
      }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
        form: form,
        onFinish: onFinish,
        layout: "vertical",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "result_string",
          label: "Resultat",
          children: /*#__PURE__*/_jsx(ReactQuill, {
            theme: "snow",
            value: resultString,
            onChange: setResultString
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: "Norme",
          name: "normal_value",
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsxs(Form.Item, {
          children: [/*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/_jsx(Button, {
              icon: /*#__PURE__*/_jsx(UploadIc, {
                size: 20
              }),
              children: /*#__PURE__*/_jsx("b", {
                children: " Joindre un fichier"
              })
            })
          })), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Space, {
          direction: "horizontal",
          children: /*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              loading: isFormProcessing,
              type: "primary",
              htmlType: "submit",
              children: /*#__PURE__*/_jsx("b", {
                children: " Sauvegarder"
              })
            })
          })
        })]
      })]
    })
  });
};
export default LaboForm;